import { createTranslations } from '@npco/utils-translations'

export const expenseCardBudgetExceededTranslations = createTranslations({
  messageAdmin:
    'Your account may not have enough funds to support the remaining budget. Please top up your account to avoid declined transactions.',
  message:
    'Your account may not have enough funds to support your remaining budget. Please contact an Admin to top up funds.',
  addFundsButton: 'Add Funds',
})
